import Vue from 'vue'
import Vuex from 'vuex'
import * as lockr from 'lockr'
// import example from './module-example'
import { Cookies } from 'quasar'
import apis from 'assets/js/Apis'
import urls from 'assets/js/urls'

Vue.use(Vuex)

/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Store instance.
 */

export default function ({ ssrContext }) {
    const cookies = process.env.SERVER ? Cookies.parseSSR(ssrContext) : Cookies // 否则我们在客户端
    const Store = new Vuex.Store({
        modules: {
            // example
        },
        state: {
            isIntegral: 10,
            nuxtServerInit: false,
            theme: process.env.SERVER ? 'light' : window.localStorage.getItem('theme') || 'light',
            noticeTotal: 0,
            // 货币规则
            unitRule: { symbol: '¥', digit: 2, ways: 10 },
            globalConfig: {},
            homeConfig: [],
            asyncData: {},
            seoData: {},
            siteCustomer: {},
            payList: [],
            customForm: {},
            addressList: {},
            addressLibrary: [],
            kfIsShow: false,
            token: cookies.get('PC_TOKEN') || '',
            userInfo: {
                extendInfo: {},
            },
            relationSaleInfo: {},
            listParam: {},
            unenoughStockSale: 10,
            huobi: '￥',
            analysisCategory: {},
            userpathInfo: [],
            categoryTree: [],
            integralCategoryTree: [],
            isAttrCard: false,
            isLogin: false,
            catCount: {},
            sysConfig: {},
            region: JSON.parse(window.sessionStorage.getItem('region') || '[]'),
            rightsTypeOptions: [],
            searchParams: {
                goodsKeyWord: '',
                cateId: '',
                brandIdList: [],
                brandIndexList: [],
                attributeList: [],
                searchType: 1, // 1: 关键字搜索，2：产线搜索 3：品牌搜索 4：属性搜索
            },
            introAlert: {
                show: false,
                loginInfo: {},
                registerInfo: {},
            }
        },
        mutations: {
            set_searchParams(state, data) {
                state.searchParams = data
            },
            set_dict(state, { type, data }) {
                state[`${type}Options`] = data
            },
            set_globalConfig(state, data) {
                state.globalConfig = data ? JSON.parse(data) : {}
            },
            global_sysConfig(state, data) {
                state.sysConfig = data.optionData ? JSON.parse(data.optionData) : {}
            },
            async set_homeConfig(state, data) {
                const config = [...data]
                const transform = ['goodsgroup']

                for (let index = 0; index < config.length; index++) {
                    const item = config[index]
                    if (item.widgets.content && typeof item.widgets.content == 'string') {
                        item.widgets.content = JSON.parse(item.widgets.content)
                        if (item.widgets.content.extendData) {
                            try {
                                item.widgets.content.extendData = JSON.parse(item.widgets.content.extendData)
                            } catch (e) {}
                        }
                    } else {
                        if (transform.includes(item.widgets.name)) {
                            item.widgets.content = {}
                        } else {
                            item.widgets.content = []
                        }
                    }
                }
                state.homeConfig = config
            },
            set_seoData(state, data) {
                state.seoData = data
            },
            set_integral(state, data) {
                if (data[0] && data[0].bizParam) {
                    const bizParam = JSON.parse(data[0].bizParam)
                    state.isIntegral = bizParam?.status == 10 && bizParam?.integDeduct == 10 ? 10 : 20
                }
            },
            set_payList(state, data) {
                state.payList =
                    data?.map(item => {
                        return {
                            label: item.payName,
                            value: item.payCode,
                            ...item,
                        }
                    }) || []
            },
            set_theme(state, data) {
                if (process.env.SERVER) return
                if (data == 'dark') {
                    document.documentElement.classList.add('theme-dark')
                    document.documentElement.classList.add('dark')
                    document.documentElement.classList.remove('theme-light')
                    document.documentElement.classList.remove('light')
                } else {
                    document.documentElement.classList.remove('theme-dark')
                    document.documentElement.classList.remove('dark')
                    document.documentElement.classList.add('theme-light')
                    document.documentElement.classList.add('light')
                }
                state.theme = data
                window.localStorage.setItem('theme', state.theme)
            },
            set_notice_total(state, data) {
                console.log(data)
                state.noticeTotal = data
            },
            nuxtServerInit(state, data) {
                state.nuxtServerInit = data
            },
            set_categoryTree(state, data) {
                state.categoryTree = data
            },
            set_integralCategoryTree(state, data) {
                state.integralCategoryTree = data[0]?.childrenList || []
            },
            set_listParam(state, data) {
                if (data[0] && data[0].bizParam) {
                    state.listParam = JSON.parse(data[0].bizParam)
                    state.unenoughStockSale = state.listParam.unenoughStockSale
                }
            },
            set_siteCustomer(state, data) {
                state.siteCustomer = data
            },
            set_analysisCategory(state, context) {
                const categoryTree = [...state.categoryTree]
                let list = []

                function getItem(val, id) {
                    val.forEach(item => {
                        if (item.id == id) {
                            list.unshift(item)
                            getItem(categoryTree, item.parentId)
                        } else {
                            if (item.list && item.list.length) {
                                getItem(item.list, id)
                            }
                        }
                    })
                }

                if (context && context != 'all') {
                    getItem(categoryTree, context)
                    const data = { ...list[list.length - 1] }
                    if (data.list && data.list.length) {
                        list.push({ id: 'all', list: data.list })
                    }
                } else {
                    list = [{ id: 'all', list: categoryTree }]
                }
                const ids = []
                // 返回出最后一级ID
                list.forEach(item => {
                    if (item.id && item.id != 'all') {
                        ids.push(item.id)
                    }
                })
                const cateId = ids[ids.length - 1]
                state.analysisCategory = { cateId, categoryIdList: [cateId] }
            },
            setUnitRule(state, data) {
                // if (!data.optionData) return
                state.unitRule = data || {}
            },
            setHb(state, data) {
                // if (!data.optionData) return
                state.huobi = data?.symbol || '¥'
            },
            setUserPath(state, data) {
                state.userpathInfo = data
            },
            SET(state, context) {
                state.asyncData = context || {}
            },
            setAddressLibrary(state, context) {
                const now = new Date()
                const expireHours = 24
                const addressLibrary = context.expiry ? context : {
                    value: context.value,
                    expiry: now.getTime() + (expireHours * 60 * 60 * 1000), // 过期时间戳
                }
                if(context.value) {
                    state.addressLibrary = context.value
                    window.localStorage.setItem('addressLibrary', JSON.stringify(addressLibrary))
                }
            },
            setCartCount(state, data) {
                state.catCount = data
            },
            SET_ADDRESS(state, data) {
                tools.getTree(data, {})
                state.addressList = tools.obj
            },
            userInfo(state, name) {
                // 用户信息
                if (name) {
                    // cookies.set("userInfo", name);
                    state.userInfo = name
                } else {
                    state.userInfo = {}
                }
            },
            loginState(state, name) {
                state.isLogin = name
            },
            setToken(state, name) {
                state.token = name
                cookies.set('PC_TOKEN', name, { path: '/' })
            },
            set_relationSaleInfo(state, data = {}) {
                state.relationSaleInfo = data || {}
            },
            setCustomForm(state, name) {
                state.customForm = name
            },
            showKf(state, data) {
                state.kfIsShow = data
            },
            set_isAttrCard(state, data) {
                state.isAttrCard = data
            },
            set_region(state, data) {
                state.region = data
                window.sessionStorage.setItem('region', JSON.stringify(data))
            },
            set_introAlertShow(state, data) {
                state.introAlert.show = data
            },
        },
        actions: {
            async getSysDict({commit, state}, {type,code}){
                let data = []
                const ret = await this.apiGet('sysDict', { dictCode: code, pageSize: 10000 })
                data = Object.freeze(ret.data) || []
                commit('set_dict', { type, data })
            },
            loginState({ commit }, is) {
                commit('isLogin', is)
            },
            async loginOut({ commit, state }, content) {
                cookies.remove('PC_TOKEN', { path: '/' })
                commit('setToken', '')
                if (content) {
                    window.location.href = window.location.origin + '/login?redirect=' + content
                    // this.$router.push('/login?redirect=' + content)
                } else {
                    // this.$router.push('/login')
                    window.location.href = window.location.origin + '/login'
                }
                commit('setCartCount', { totalCount: 0 })
                this.$axios.get(apis.data().apis.loginout).then(res => {
                    commit('userInfo')
                    commit('loginState', false)
                })
            },
            setUserPath({ commit, state }, data) {
                commit('setUserPath', data)
            },
            userInfo({ commit, state }, data) {
                commit('userInfo', data)
            },
            showKf({ commit, state }, data) {
                commit('showKf', data)
            },
            setCartCount({ commit, state }) {
                if (!state.isLogin) {
                    var localCartList = lockr.get('cartList')
                    var count = 0
                    localCartList &&
                        localCartList.length &&
                        localCartList.forEach((v, k) => {
                            if (v.quantity) {
                                count += v.quantity
                            }
                        })
                    return commit('setCartCount', { totalCount: count })
                }
                // commit('userInfo',data);
                this.$axios.get(apis.data().apis.bbbUserShoppingCarCount).then(res => {
                    commit('setCartCount', res.data)
                })
            },
            async setToken({ commit, dispatch, state }, data) {
                commit('setToken', data.token)
                const res = await this.$axios.get(apis.data().apis.bbbUserCenterGetUserInfo)
                dispatch('nuxtServerInit', data)
                if (res.code == 200) {
                    const localCartList = lockr.get('cartList')
                    if (localCartList && localCartList.length) {
                        await this.$axios.post(apis.data().apis.bbbUserShoppingCarAdd, {
                            skuGoodsList: localCartList,
                        })
                        lockr.rm('cartList')
                    }
                }
            },
            async nuxtServerInit({ commit, state, dispatch }, data) {
                return new Promise(async (resolve, reject) => {
                    const p1 = this.$axios.get(urls['getSeo'], {
                        params: { seoCode: '1000601' },
                    })
                    const p2 = this.$axios.get(urls['categoryTree'], { params: { bizType: 1 } })
                    const p3 = this.$axios.get('/bbb/pc/settings/currency')
                    const p4 = this.$axios.get(urls['theme'], {
                        params: { type: 1 },
                    })
                    const p5 = this.$axios.get('/bbb/h5/siteCustomer')

                    const p6 = this.$axios.get(urls['categoryTree'], { params: { bizType: 2 } })

                    let [seoData, categoryTree, huobi, config, siteCustomer, integralCategoryTree] = await Promise.all([
                        p1,
                        p2,
                        p3,
                        p4,
                        p5,
                        p6,
                    ])
                    const goods = ['pc-goods-card', 'pc-floor']
                    for (let i = 0; i < config.data.content.length; i++) {
                        const item = config.data.content[i]
                        if (goods.includes(item.name)) {
                            const idList = item.widgets.content ? JSON.parse(item.widgets.content) : {}
                            // console.log(idList.data, '查看数据')
                            const { data } = await this.$axios.post('bbb/goodsInfo/listData', {
                                idList: idList.data,
                                sortByParamId: true
                            })
                            // const orderMap = new Map(idList.data.map((id, index) => [id, index]))
                            const jsonArray = data
                            // 使用sort方法对jsonArray进行排序
                            // jsonArray?.sort((a, b) => {
                            //     // 如果找不到对应的id，则赋予一个很大的值，确保未列出的项排在最后
                            //     const indexA = orderMap.get(a.id) ?? Infinity
                            //     const indexB = orderMap.get(b.id) ?? Infinity
                            //     return indexA - indexB
                            // })
                            idList.data = jsonArray
                            item.widgets.content = JSON.stringify(idList)
                        }
                    }

                    commit('set_homeConfig', config.data.content || [])
                    commit('set_globalConfig', config.data.globalThemeSetting)
                    commit('set_seoData', seoData.data || {})
                    commit('set_categoryTree', categoryTree.data || [])
                    commit('set_integralCategoryTree', integralCategoryTree.data || [])
                    commit('set_siteCustomer', siteCustomer.data || [])

                    if (huobi.code == 200) {
                        commit('setHb', huobi.data)
                        commit('setUnitRule', huobi.data)
                    }

                    //初始化登录信息
                    if (state.token) {
                        const p1 = this.$axios.get(urls['bbbUserCenterGetUserInfo'])
                        const p2 = this.apiGet('/bbb/userCenter/tradePay/listPayType')
                        const p3 = this.apiGet('bbbUserShoppingCarCount')
                        const p4 = this.$axios.get('/bbb/home/getSiteOption', {
                            params: { optionName: '0000001', optionCodeGroup: '10' },
                        })
                        const p5 = this.$axios.post('bbb/userCenter/remind/pageRemind', { state: 10, bizType: '04' })
                        const p6 = this.$axios.get('/bbb/userCenter/listParam', { params: { code: 6001 } })
                        const p7 = this.$axios.get('/bbb/userCenter/listParam', { params: { code: 6004 } })
                        let [user, payList, count, config, notice, listParam, integral] = await Promise.all([
                            p1,
                            p2,
                            p3,
                            p4,
                            p5,
                            p6,
                            p7,
                        ])
                        commit('set_integral', integral.data)
                        commit('set_payList', payList.data)
                        if (count.code == 200) {
                            commit('setCartCount', count.data)
                        }

                        if (notice.code == 200) {
                            commit('set_notice_total', notice.data.total)
                        }
                        commit('set_listParam', listParam.data || [])
                        commit('global_sysConfig', config.data || [])
                        if (user.code == 200) {
                            commit('userInfo', {
                                ...user.data,
                            })
                            dispatch('getRelationSaleInfo')
                            if (data) {
                                const userType = user.data.userType
                                if (userType == 10 && data.path == '/') {
                                    this.$router.push({
                                        path: '/',
                                    })
                                } else {
                                    this.$router.push({
                                        path: data.path || '/',
                                    })
                                }
                            }
                        } else {
                            cookies.remove('PC_TOKEN', { path: '/' })
                        }
                    }
                    commit('nuxtServerInit', true)
                    resolve()
                })
            },
            async getAddressOptions({ commit, state }, data) {
                const itemStr = window.localStorage.getItem('addressLibrary') || JSON.stringify({expiry:0})
                const addressLibrary = JSON.parse(itemStr)
                const now = new Date();
                if (addressLibrary.value && addressLibrary.value.length && (now.getTime() < addressLibrary.expiry)) {
                    commit('setAddressLibrary', addressLibrary)
                }else{
                    const res = await this.$axios.get(apis.data().apis.getAddressList)
                    if (res.code == 200) {
                        commit('setAddressLibrary', {value: res.data})
                    }
                }
            },
            // 获取用户关联的销售人员信息
            async getRelationSaleInfo({ commit, state }) {
                const extendInfo = state.userInfo?.extendInfo || {}
                if (!state.token) {
                    commit('set_relationSaleInfo')
                    return
                }

                try {
                    if (extendInfo.relationSaleId) {
                        const res = await this.apiGet(`/bbb/userCenter/sysUser/${extendInfo.relationSaleId}`, {})
                        if (res.code === 200) {
                            commit('set_relationSaleInfo', {
                                relationSaleName: res.data.realName,
                                relationSalePhone: res.data.phone,
                                relationSaleEmail: res.data.email,
                                relationSaleQrCode: res.data.qrCode,
                            })
                            return
                        }
                    }

                    commit('set_relationSaleInfo', {
                        relationSaleName: extendInfo.relationSaleName,
                        relationSalePhone: extendInfo.relationSalePhone,
                        relationSaleEmail: extendInfo.relationSaleEmail,
                    })
                } catch (error) {
                    commit('set_relationSaleInfo')
                }
            }
        },
    })

    return Store
}
